/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { OrganizationAwareFuseNavigationItem } from 'app/core/navigation/navigation.types';
export const defaultNavigation: OrganizationAwareFuseNavigationItem[] = [

            {
                id   : 'dashboards.project',
                title: 'Dashboard',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-document-check',
                link : '/dashboard',
            },
            {
                id   : 'myaccount',
                title: 'My Account',
                type : 'basic',
                icon : 'mat_outline:manage_accounts',
                link : '/myaccount',
            },
            {
                id      : 'bai-management',
                title   : 'BAI Member Management',
                type    : 'collapsable',
                icon    : 'heroicons_outline:user-group',
                forOrganizationNames: ['bai Store'],
                children: [
                    {
                        id   : 'member-management.buyer',
                        title: 'BAI Buyer Management',
                        type : 'basic',
                        icon : 'heroicons_outline:users',
                        link : '/bai-management/buyers',
                    },
                    {
                        id   : 'member-management.seller',
                        title: 'BAI Seller Management',
                        type : 'basic',
                        icon : 'heroicons_outline:users',
                        link : '/bai-management/sellers',
                    },
                    {
                        id   : 'mr-management',
                        title: 'MR Management',
                        type : 'basic',
                        icon : 'heroicons_outline:users',
                        link : '/bai-management/mr-management',
                    },
                ],
            },
            {
                id      : 'user-management',
                title   : 'User Management',
                type    : 'collapsable',
                icon    : 'heroicons_outline:user-group',
                children: [
                    {
                        id   : 'user-management.company',
                        title: 'Company Management',
                        type : 'basic',
                        icon : 'heroicons_outline:users',
                        link : '/user-management/company',
                        forOrganizationNames: ['bai Store'],

                    },
                    {
                        id   : 'user-management.seller',
                        title: 'Seller Management',
                        type : 'basic',
                        icon : 'heroicons_outline:users',
                        link : '/user-management/seller',
                        forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],
                    },
                    {
                        id   : 'user-management.buyer',
                        title: 'Buyer Management',
                        type : 'basic',
                        icon : 'heroicons_outline:users',
                        link : '/user-management/buyer',
                        forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],
                    },
                    {
                        id   : 'user-management.participant',
                        title: 'Participant Management',
                        type : 'basic',
                        icon : 'heroicons_outline:users',
                        link : '/user-management/participant',
                        forOrganizationNames: ['bai Store','Spices Mandi','KSPE','TCB REALTY','Grandis'],
                    },
                    {
                        id   : 'user-management.usergroup',
                        title: 'User Group',
                        type : 'basic',
                        icon : 'heroicons_outline:users',
                        link : '/user-management/usergroup',
                    },
                    {
                        id   : 'user-management.userbin',
                        title: 'User Bin',
                        type : 'basic',
                        icon : 'heroicons_outline:trash',
                        link : '/user-management/userbin',
                    },
                    // {
                    //     id   : 'user-management.seller-2',
                    //     title: 'Seller Management - 2',
                    //     type : 'basic',
                    //     icon : 'heroicons_outline:users',
                    //     link : '/user-management/seller-2',
                    // },
                ],
            },
            {
                id      : 'stock-management',
                title   : 'Stock Management',
                type    : 'collapsable',
                icon    : 'heroicons_outline:chart-bar-square',
                forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],

                children: [
                    
                    {
                        id   : 'stock-management.stock-management',
                        title: 'Stocks',
                        type : 'basic',
                        icon : 'heroicons_outline:chart-bar-square',
                        link : '/stock-management/stock-management',
                    },     {
                        id   : 'stock-management.purchase-orders',
                        title: 'Purchase Orders',
                        type : 'basic',
                        icon : 'heroicons_outline:chart-bar-square',
                        link : '/stock-management/purchase-orders',
                    },  {
                        id   : 'stock-management.stock-bin',
                        title: 'Stock Bin',
                        type : 'basic',
                        icon : 'heroicons_outline:trash',
                        link : '/stock-management/stock-bin',
                    },
                ],
            },
            {
                id      : 'purchase-order-management',
                title   : 'Purchase Management',
                type    : 'collapsable',
                icon    : 'heroicons_outline:chart-bar-square',
                forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],
                children: [
                   {
                        id   : 'purchase-order-management.enquiries',
                        title: 'Enquiries',
                        type : 'basic',
                        icon : 'heroicons_outline:chart-bar-square',
                        link : '/purchase-order-management/enquiries',
                    },  {
                        id   : 'stock-management.purchase-orders',
                        title: 'Purchase Orders',
                        type : 'basic',
                        icon : 'heroicons_outline:trash',
                        link : '/purchase-order-management/purchase-orders',
                    },
                    {
                        id   : 'purchase-order-management.material-requests',
                        title: 'Material Requests',
                        type : 'basic',
                        icon : 'heroicons_outline:document-text',
                        link : '/material-requests',
                    },
                ],
            },
            {
                id      : 'CSV-export-management',
                title   : 'CSV Export Management',
                type    : 'collapsable',
                icon    : 'feather:upload-cloud',
                forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],
                children: [
                    {
                        id   : 'stock-upload.cardamom',
                        title: 'Stock Upload-Cardamom',
                        type : 'basic',
                        icon : 'feather:upload-cloud',
                        link : '/stock-management/stock-upload-cardamom',
                    },
                    {
                        id   : 'stock-upload.pepper',
                        title: 'Stock Upload-Pepper',
                        type : 'basic',
                        icon : 'feather:upload-cloud',
                        link : '/stock-management/stock-upload-pepper',
                    },
                    {
                        id   : 'stock-upload.others',
                        title: 'Stock Upload-Others',
                        type : 'basic',
                        icon : 'feather:upload-cloud',
                        link : '/stock-management/stock-upload-new',
                    },        {
                        id   : 'stock-upload.update',
                        title: 'Stock Update',
                        type : 'basic',
                        icon : 'feather:upload-cloud',
                        link : '/stock-management/stock-update',
                    },
                ],
            },  
            {
                id      : 'offer-management',
                title   : 'Offer Management',
                type    : 'basic',
                icon    : 'heroicons_outline:chart-bar',
                link : '/offer-management',
                forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],

            },
            {
                id      : 'live-auction-mngmt',
                title   : 'Live Auction Managment',
                type    : 'collapsable',
                icon    : 'heroicons_outline:user-group',
                forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],

                children: [
                    {
                        id   : 'live.create-auction',
                        title: 'Create Auction',
                        type : 'basic',
                        icon : 'how_to_vote',
                        link : '/live-auction/create-auction',
                    },
                    {
                        id   : 'live.auction-settings',
                        title: 'Auction Settings',
                        type : 'basic',
                        icon : 'ondemand_video',
                        link : '/live-auction/auction-settings',
                    },
                    {
                        id   : 'live.auction-managment',
                        title: 'Live Auction Managrment',
                        type : 'basic',
                        icon : 'ondemand_video',
                        link : '/live-auction/auction-managment',
                    },
                    {
                        id   : 'live.auction-monitoring',
                        title: 'Live Auction Monitoring',
                        type : 'basic',
                        icon : 'ondemand_video',
                        link : '/live-auction/live-monitoring',
                    }]
                },

                {
                    id      : 'trade-mngmt',
                    title   : 'Trade Managment',
                    type    : 'collapsable',
                    icon: 'portable_wifi_off',
                    forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],

                    children: [{
                        id   : 'trade-management',
                        title: 'Trade Management',
                        type : 'basic',
                        icon: 'portable_wifi_off',
                        link : '/offline-management/purchase-enquiries',
                    }]
                },
                
            {
                id      : 'offline-auction-mngmt',
                title   : 'Offline Auction Managment',
                type    : 'collapsable',
                icon: 'portable_wifi_off',
                forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],

                children: [
                                      {
                        id   : 'offline-settings',
                        title: 'Offline Settings',
                        type : 'basic',
                        icon: 'portable_wifi_off',
                        link : '/offline-management/offline-settings',
                    },
                    {
                        id   : 'offline-managment',
                        title: 'Stocks Auctions',
                        type : 'basic',
                        icon: 'portable_wifi_off',
                        link : '/offline-management/offline-managment',
                    },
                    {
                        id   : 'purhcase order-offer-managment',
                        title: 'Purchase Offer',
                        type : 'basic',
                        icon: 'portable_wifi_off',
                        link : '/offline-management/purchase-order-offer',
                    },
                    ]
                },
                {
                    id      : 'wallet',
                    title   : 'Wallet Management',
                    type    : 'collapsable',
                    icon    : 'heroicons_outline:wallet',
                    forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],
    
                    children: [
                        {
                            id   : 'wallet.seller-payout',
                            title: 'Seller Payout',
                            type : 'basic',
                            icon : 'heroicons_outline:pencil',
                            link : '/wallet/seller-payout',
                        },
                        {
                            id   : 'wallet.create-payout',
                            title: 'Create Payout',
                            type : 'basic',
                            icon : 'heroicons_outline:pencil',
                            link : '/wallet/create-payout',
                        },
                        {
                            id   : 'wallet.payout-files',
                            title: 'Payout Files',
                            type : 'basic',
                            icon : 'heroicons_outline:document-text',
                            link : '/wallet/payout-files',
                        },
                        {
                            id   : 'wallet.tax-refund',
                            title: 'Tax Refund',
                            type : 'basic',
                            icon : 'heroicons_outline:pencil',
                            link : '/wallet/tax-refund',
                        },
                    ],
                },
                {
                    id      : 'wallet-report',
                    title   : 'Wallet Report',
                    type    : 'collapsable',
                    icon    : 'heroicons_outline:document-text',
                    forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],
    
                    children: [
                        {
                            id   : 'wallet-report.stock-amount',
                            title: 'Stock Amount',
                            type : 'basic',
                            icon : 'heroicons_outline:clipboard-document-list',
                            link : '/wallet-report/stock-amount',
                        },
                        {
                            id   : 'wallet-report.credit-list',
                            title: 'Credit List',
                            type : 'basic',
                            icon : 'heroicons_outline:clipboard-document-list',
                            link : '/wallet-report/credit-list',
                        },
                        {
                            id   : 'wallet-report.refund-return-files',
                            title: 'Refund Return Files',
                            type : 'basic',
                            icon : 'heroicons_outline:credit-card',
                            link : '/wallet-report/refund-return-files',
                        },
                        {
                            id   : 'wallet-report.unmatched-records',
                            title: 'Unmatched Records',
                            type : 'basic',
                            icon : 'heroicons_outline:clipboard-document-check',
                            link : '/wallet-report/unmatched-records',
                        },
                        {
                            id   : 'wallet-report.refund-return-files-upload',
                            title: 'Refund Return File Upload',
                            type : 'basic',
                            icon : 'heroicons_outline:clipboard-document-check',
                            link : '/wallet-report/refund-return-file-upload',
                        },
                    ],
                },
    


            {
                id      : 'report',
                title   : 'Report',
                type    : 'collapsable',
                icon    : 'mat_solid:table_chart',
                forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],

                children: [
                    {
                        id   : 'report.lotwise-report',
                        title: 'Lotwise Report -1',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/lotwise-report-1',
                    },
                    {
                        id   : 'report.lotwise-report-2',
                        title: 'Lotwise Report -2',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/lotwise-report-2',
                    },
                    {
                        id   : 'report.bid-report',
                        title: 'Bid Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/bid-report',
                    },
                    {
                        id   : 'report.retial-report',
                        title: 'Retail Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/retail-report',
                    },
                    {
                        id   : 'report.stockamount-report',
                        title: 'Stock Amount Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/stockamount-report',
                    },
                    {
                        id: 'report.bidderwise-report',
                        title: 'BidderWise Report',
                        type: 'basic',
                        link: '/reports/bidderwise-report',
                        icon: 'heroicons_mini:chart-bar',
                      },
                    {
                        id   : 'report.seller-report',
                        title: 'Seller Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/seller-report',
                    },
                    {
                        id   : 'report.buyer-report',
                        title: 'Buyer Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/buyer-report',
                    },
                    {
                        id   : 'report.advanced-auction-report',
                        title: 'Advanced Auction Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/advanced-auction-report',
                    },
                    {
                        id   : 'report.auction-report',
                        title: 'Auction Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/auction-report',
                    },
                    {
                        id   : 'report.auction-list',
                        title: 'Auction List',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/auction-list-report',
                    },
                    {
                        id   : 'report.margin-report',
                        title: 'Margin Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/margin-report',
                    },
                    {
                        id   : 'report.buyer-statement',
                        title: 'Buyer Statement',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/buyers-statement',
                    },
                    {
                        id   : 'report.dealer-report',
                        title: 'Dealer Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/dealer-report',
                    },
                    {
                        id   : 'report.invoice',
                        title: 'Invoice',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/invoice-report',
                    },
                    {
                        id   : 'report.stock-report',
                        title: 'Stock Report',
                        type : 'basic',
                        icon : 'heroicons_mini:chart-bar',
                        link : '/reports/stock-report',
                    },
                ],
            },
            {
                id      : 'product-categories',
                title   : 'Product & Categories',
                type    : 'collapsable',
                icon    : 'heroicons_outline:document-text',
                forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],

                children: [
                    {
                        id   : 'product-categories.categories',
                        title: 'Categories',
                        type : 'basic',
                        icon : 'heroicons_outline:clipboard-document-list',
                        link : '/product-management/categories',
                    },
                    {
                        id   : 'product-categories.products',
                        title: 'Products',
                        type : 'basic',
                        icon : 'heroicons_outline:clipboard-document-list',
                        link : '/product-management/products',
                    },
                ],
            },
            {
                id: 'feedback',
                title: 'Feedback',
                type: 'basic',
                link: '/feedback',
                icon: 'mat_outline:feedback'
                
              },

              {
                id: 'settings',
                title: 'Organization Settings',
                type: 'basic',
                link: '/setting',
                icon: 'mat_outline:settings'
              },
              {
                id   : 'organization',
                title: 'Organization',
                type : 'collapsable',
                icon : 'mat_outline:supervised_user_circle',
                children: [
                    {
                        id   : 'org-details',
                        title: 'Organization Details',
                        type : 'basic',
                        icon : 'heroicons_outline:user-group',
                        link : 'organization/org-details',
                    },
                    {
                        id   : 'org-user-details',
                        title: 'User & Organization',
                        type : 'basic',
                        icon : 'heroicons_outline:user-group',
                        link : 'organization/user-org',
                    },
                ]
            },
            {
                id   : 'option',
                title: 'Option Managment',
                type : 'collapsable',
                icon : 'mat_outline:store',
                forOrganizationNames: ['bai Store'],

                children: [
                    {
                        id   : 'options',
                        title: 'Options',
                        type : 'basic',
                        icon : 'heroicons_outline:user-group',
                        link : 'option-managment/options',
                    },
                    {
                        id   : 'option-group',
                        title: 'Option Group',
                        type : 'basic',
                        icon : 'heroicons_outline:user-group',
                        link : 'option-managment/option-group',
                    },
                ]
            },
              {
                id: 'system-health',
                title: 'System Health',
                type: 'basic',
                link: '/system-health',
                icon: 'mat_outline:settings'
              },


            {
                id      : 'user-allocation',
                title   : 'User Allocation',
                type    : 'basic',
                icon    : 'heroicons_outline:briefcase',
                link : '/user-allocation',
                forOrganizationNames: ['bai Store','Spices Mandi','KSPE'],

            },
            {
                id      : 'property-managment',
                title   : 'Property Managment',
                type    : 'basic',
                icon    : 'heroicons_outline:briefcase',
                link : '/properties',
                forOrganizationNames: ['TCB REALTY','Grandis'],

            },


];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];

